import { Component } from '@angular/core';

@Component({
    selector: 'app-logo',
    imports: [],
    templateUrl: './logo.component.html',
    standalone: true,
    styleUrl: './logo.component.scss'
})
export class LogoComponent{}
